import {
  SectionElement,
  defineElement,
  onClick,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/sections/new-logos/new-logos.ts
var NewLogos = class extends SectionElement {
  constructor() {
    super(...arguments);
    this.isStaticView = false;
  }
  handleA11yToggle() {
    this.isStaticView = !this.isStaticView;
    this.updateView();
  }
  updateView() {
    var _a;
    if (!this.scrollView || !this.staticView || !this.a11yToggle)
      return;
    if (this.isStaticView) {
      this.scrollView.classList.add("hidden");
      this.staticView.classList.remove("hidden");
      this.a11yToggle.setAttribute("aria-pressed", "true");
      this.a11yToggle.textContent = "$t(Animierte Ansicht anzeigen)";
      (_a = this.staticView.querySelector("a")) == null ? void 0 : _a.focus();
    } else {
      this.scrollView.classList.remove("hidden");
      this.staticView.classList.add("hidden");
      this.a11yToggle.setAttribute("aria-pressed", "false");
      this.a11yToggle.textContent = "$t(Statische Ansicht anzeigen)";
    }
  }
};
__decorateClass([
  query("[data-a11y-toggle]")
], NewLogos.prototype, "a11yToggle", 2);
__decorateClass([
  query("[data-scroll-view]")
], NewLogos.prototype, "scrollView", 2);
__decorateClass([
  query("[data-static-view]")
], NewLogos.prototype, "staticView", 2);
__decorateClass([
  onClick("[data-a11y-toggle]")
], NewLogos.prototype, "handleA11yToggle", 1);
NewLogos = __decorateClass([
  defineElement("new-logos")
], NewLogos);
export {
  NewLogos
};
